import React from 'react';
import { Accordion, styled } from '@mui/material';
import theme from '../../constants/theme';

export const AccordionStyled = styled(Accordion)({
  background: `${theme.palette.secondary.main} !important`,
  width: 'auto',
  border: 'unset',
  boxShadow: 'none',
  maxWidth: 'unset !important',
  marginTop: 'unset !important',
  svg: {
    color: theme.palette.text.secondary,
  },
  '.MuiAccordionSummary-root': {
    padding: '16px 0',
    alignItems: 'start',
  },
  '.MuiAccordionDetails-root': {
    padding: 0,
  },
  h6: {
    fontSize: theme.typography.h6.fontSize,
  },
  h3: {
    fontSize: theme.typography.h5.fontSize,
  },
  '.Mui-expanded': {
    svg: {
      color: `${theme.palette.primary.main} !important`,
    },
    h5: {
      color: `${theme.palette.primary.main} !important`,
    },
  },
  '::before': {
    opacity: '1 !important',
  },
  '.MuiAccordionSummary-content': {
    margin: 0,
    flexDirection: 'column',
  },
  '.MuiAccordionSummary-content.Mui-expanded': {
    margin: 0,
  },
});
